import { AI_MAX_WINDOW_DAYS, AI_WINDOW_DAYS } from '@steado/admin-contract/ai-ops';
import { z } from 'zod';

/** The windows the screen offers. Free-form days would be a filter nobody uses. */
export const AI_WINDOW_OPTIONS = [7, 30, 90] as const;

/**
 * One filter, in the URL like every other screen's: "the last week of AI spend"
 * should be a link.
 */
export const aiOpsSearchSchema = z.object({
  days: z.coerce.number().int().min(1).max(AI_MAX_WINDOW_DAYS).default(AI_WINDOW_DAYS).catch(AI_WINDOW_DAYS),
});

export type AiOpsSearch = z.infer<typeof aiOpsSearchSchema>;
